import { Button } from '@/common/ui/button'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import useMutationDeleteGroup from '@/modules/manage-member/api/hooks/useMutateDeleteGroup'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'
import { useIsCurrentUserGroup } from '@/modules/manage-member/hooks/useIsCurrentUserGroup'

interface DeleteGroupModalProps {
	id: string
}

export default function DeleteGroupModal({ id }: DeleteGroupModalProps) {
	const queryClient = useQueryClient()
	const { mutate: deleteGroup } = useMutationDeleteGroup({
		onSuccess: () => {
			toast.success('ลบประเภทผู้ดูแลระบบสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [OperatorQueryKeys.GetMemberGroup],
			})
		},
		onError: (error) => {
			showErrorToast(
				error ||
					'ไม่สามารถลบประเภทผู้ดูแลระบบได้ เนื่องจากมีผู้ใช้งานอยู่ โปรดเอาผู้ดูแลระบบทั้งหมดออกจากประเภทผู้ดูแลระบบนี้ก่อน',
			)
		},
	})

	const isCurrentUserGroup = useIsCurrentUserGroup(id)

	if (isCurrentUserGroup) return null

	const handleDelete = () => {
		deleteGroup({ id })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบประเภทผู้ดูแลระบบ</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบประเภทผู้ดูแลระบบนี้ใช่หรือไม่?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter className="gap-2">
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction
						onClick={handleDelete}
						className="bg-destructive hover:bg-destructive/90"
					>
						ยืนยัน
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
